"use strict";
var lib_core = require("lib-core");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var AbstractPosInteractionModel = require("./abstractPosInteractionModel.js");
var cio_config = require("cio-config");

var AbstractPosAngleInteractionModel = function (data, editorModel, options) {
    var self = this;
    AbstractPosInteractionModel.call(this, data, editorModel, options);

    this.showAngle = this.shadow("showAngle",
        function () {
            return self.data.angle();
        },
        function (value) {
            return self.data.angle(((value%360)+360)%360);
        },
        [this.data.angle]
    );
};
lib_core.inherit(AbstractPosAngleInteractionModel, AbstractPosInteractionModel);

module.exports = AbstractPosAngleInteractionModel;

AbstractPosAngleInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = AbstractPosInteractionModel.prototype.getInspectorElements.call(this);

    if(this.options.angle_restriction) {
        var allowed_angles_selectbox = this.options.angle_restriction.map(function(angle)
            { return [angle+'°', angle]; });
        inspectorElements.input_elements.push({
                label: 'Rotation',
                type: ui_extensions.InspectorInputType.SELECTBOX,
                datamember: this.showAngle,
                list: allowed_angles_selectbox
            }
        );
    } else {
        inspectorElements.input_elements.push(
            {
                label      : 'Rotation',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.showAngle,
                datatype   : cio_config.types.float,
                unit       : '°'
            }
        );
    }

    return inspectorElements;
};

AbstractPosAngleInteractionModel.prototype.angle = function(angle) {
    return this.data.angle(angle);
};
